import { useEffect, useMemo } from 'react';
import { v4 as randomUuid } from 'uuid';
import { useAppStore } from '../stores/appStore';

const SESSION_ID_STORAGE_KEY = 'ai-store-builder-session-id';

function getStoredSessionId(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return sessionStorage.getItem(SESSION_ID_STORAGE_KEY);
}

function setStoredSessionId(sessionId: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(SESSION_ID_STORAGE_KEY, sessionId);
}

export function useSessionId(): string {
  const sessionId = useAppStore((state) => state.sessionId);
  const setSessionId = useAppStore((state) => state.setSessionId);

  useEffect(() => {
    if (!sessionId) {
      const storedId = getStoredSessionId();
      if (storedId) {
        setSessionId(storedId);
      } else {
        const newSessionId = randomUuid();
        setStoredSessionId(newSessionId);
        setSessionId(newSessionId);
      }
    }
  }, [sessionId, setSessionId]);

  return useMemo(() => {
    return sessionId || '';
  }, [sessionId]);
}
